import type { OauthTokenDataObject } from '../service/login';

export type OauthToken = {
  accessToken: string;
  createdAt: number;
  expiresIn: number;
  refreshToken: string;
  tokenType: string;
};

export const createOauthToken = (data: OauthTokenDataObject) => ({
  accessToken: data.access_token,
  createdAt: data.created_at,
  expiresIn: data.expires_in,
  refreshToken: data.refresh_token,
  tokenType: data.token_type,
});
